import { UnitFiltersForm } from '@mark43/cad-api';
import { Attribute } from '@mark43/rms-api';
import { Control } from 'react-hook-form';
import { useAttributeOptionsByType } from '../../../attributes/use-attribute-options-by-type';
import { FilterSelect } from './filter-select';

export function AttributeFilterSelect(props: {
    label: string;
    attributeType: Attribute['attributeType'];
    filterName: keyof UnitFiltersForm;
    parentAttributeId?: number;
    control: Control<UnitFiltersForm>;
}): React.ReactElement {
    const { attributeOptions, isInitialLoading } = useAttributeOptionsByType({
        attributeType: props.attributeType,
        parentAttributeId: props.parentAttributeId,
    });
    return (
        <FilterSelect
            options={attributeOptions}
            label={props.label}
            filterName={props.filterName}
            control={props.control}
            isLoading={isInitialLoading}
        />
    );
}
